module.exports = __webpack_public_path__ + "img/header-weddingRingsGayLesbianCouples@2x.845637a.webp";